import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Steps = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Steps" {...props}>
    <path d="M24 2H17.8193C17.0251 2.00004 16.2635 2.31515 15.7012 2.87598L2.88086 15.6641C2.31674 16.2268 2.00006 16.9913 2 17.7881V24H0V17.7881C5.686e-05 16.46 0.528484 15.186 1.46875 14.248L14.2881 1.45996C15.2254 0.524955 16.4954 4.02189e-05 17.8193 0H24V2ZM24 9.10352H20.4453V14.1035C20.4451 14.6554 19.9972 15.1033 19.4453 15.1035H14.4453V20.1035C14.4451 20.6554 13.9972 21.1033 13.4453 21.1035H8.44531V24H6.44531V21.1035C6.44531 19.9989 7.34074 19.1035 8.44531 19.1035H12.4453V15.1035C12.4453 13.9989 13.3407 13.1035 14.4453 13.1035H18.4453V9.10352C18.4453 7.99895 19.3407 7.10352 20.4453 7.10352H24V9.10352Z" fill="#000" />
  </StyledIcon>
));

Steps.displayName = 'Steps';

export { Steps };
